var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,React.createElement("path",{"style":{"stroke":"none","fillRule":"nonzero","fill":"rgb(10.588235%,10.588235%,10.588235%)","fillOpacity":"1"},"d":"M 5.207031 7 L 53.792969 7 C 54.714844 7 55.597656 6.632812 56.25 5.976562 C 56.898438 5.320312 57.265625 4.429688 57.265625 3.5 C 57.265625 2.570312 56.898438 1.679688 56.25 1.023438 C 55.597656 0.367188 54.714844 0 53.792969 0 L 5.207031 0 C 4.285156 0 3.402344 0.367188 2.75 1.023438 C 2.101562 1.679688 1.734375 2.570312 1.734375 3.5 C 1.734375 4.429688 2.101562 5.320312 2.75 5.976562 C 3.402344 6.632812 4.285156 7 5.207031 7 Z M 5.207031 7 "}));
}

Remove.defaultProps = {"width":"60px","height":"7px","viewBox":"0 0 60 7"};

module.exports = Remove;

Remove.default = Remove;
